import React from "react";
import { Link } from "react-router-dom"; 
import "./ExperienceSection.css";
import xpImg from "../assets/xp.jpg"; 

const ExperienceSection = () => {
  return (
    <section className="experience-section">
      <h2 className="experience-heading">NOSSA HISTÓRIA</h2>

      <div className="experience-content">
        <div className="experience-left-content">
          <img src={xpImg} alt="Experiência" className="experience-image" />
        </div>

        <div className="experience-right-content">
          <p className="experience-description">
            A Retroflex nasceu de um momento de desafio, quando treinar em casa
            virou necessidade e oportunidade. O projeto começou em uma garagem,
            impulsionado pela busca por performance real e pela paixão em
            construir um espaço autêntico, onde o treino fosse mais do que
            rotina, mas sim uma experiência intensa.
          </p>
          <p className="experience-description">
            Cada máquina foi escolhida com cuidado, cada detalhe pensado para
            resgatar a essência old school e elevar o padrão. Nossa estrutura
            combina tradição e modernidade, oferecendo o ambiente ideal para quem
            busca disciplina, força e evolução contínua. Aqui, nada é por acaso.
          </p>
          <p className="experience-description">
            Formamos uma comunidade unida, onde atletas, iniciantes e guerreiros
            do dia a dia treinam juntos, dividindo conquistas e incentivando uns
            aos outros. Na Retroflex, acreditamos que disciplina transforma e que
            o verdadeiro resultado nasce do esforço coletivo.
          </p>
          <p className="experience-description">
            Nossa história se escreve a cada treino, com cada pessoa que decide
            ir além. Se você busca um espaço que vai muito além de aparelhos e
            pesos, onde evolução e propósito andam lado a lado, você encontrou
            seu lugar. Seja bem-vindo à Retroflex, onde a superação nunca para.
          </p>
          
          <Link to="/sobre" className="experience-button">
            SAIBA MAIS
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
